import { v4 as uuid } from "uuid";
import { z } from "zod";
import { EmissionFactorType } from "../../entities/emissionFactor";
import { EnvironmentalCategory, EnvironmentalMetricType, EnvironmentalSubCategory, EnvironmentalTargetType } from "../../entities/environmentalCommitment";
import { ProjectCommmitmentGenerationSource } from "../project/enums";
export const projectEnvironmentalCommitmentLineItemSchema = z.object({
    category: z.enum(EnvironmentalCategory),
    created: z.date(),
    emissionFactorType: z.enum(EmissionFactorType).optional(),
    generationSource: z.enum(ProjectCommmitmentGenerationSource).optional(),
    id: z.string(),
    metricType: z.enum(EnvironmentalMetricType),
    projectId: z.string(),
    sourceFrameworkId: z.string().optional(),
    sourceFrameworkTargetId: z.string().optional(),
    subCategory: z.enum(EnvironmentalSubCategory),
    subCategoryDescription: z.string().optional(),
    targetType: z.enum(EnvironmentalTargetType)
});
export const packageEnvironmentalCommitmentLineItemSchema = z.object({
    contractorPackageId: z.string(),
    created: z.date(),
    id: z.string(),
    projectEnvironmentalCommitmentId: z.string(),
    projectId: z.string()
});
export const createDefaultProjectEnvironmentalCommitmentLineItem = (projectId) => ({
    category: EnvironmentalCategory.EnergyElectricity,
    created: new Date(),
    emissionFactorType: EmissionFactorType.Electricity,
    id: uuid(),
    metricType: EnvironmentalMetricType.KilowattHours,
    projectId,
    subCategory: EnvironmentalSubCategory.ElectricityKwh,
    targetType: EnvironmentalTargetType.EnergyAndFuelsAndLubricants
});
export const createDefaultPackageEnvironmentalCommitmentLineItem = (projectCommitment, contractorPackageId) => ({
    contractorPackageId,
    created: new Date(),
    id: uuid(),
    projectEnvironmentalCommitmentId: projectCommitment.id,
    projectId: projectCommitment.projectId
});
